import { Letter } from "../../game/types";
import LetterA from "../assets/letters/A.svg";
import LetterB from "../assets/letters/B.svg";
import LetterC from "../assets/letters/C.svg";
import LetterD from "../assets/letters/D.svg";
import LetterE from "../assets/letters/E.svg";
import LetterF from "../assets/letters/F.svg";
import LetterG from "../assets/letters/G.svg";
import LetterH from "../assets/letters/H.svg";
import LetterI from "../assets/letters/I.svg";
import LetterK from "../assets/letters/K.svg";
import LetterL from "../assets/letters/L.svg";
import LetterM from "../assets/letters/M.svg";
import LetterN from "../assets/letters/N.svg";
import LetterO from "../assets/letters/O.svg";
import LetterP from "../assets/letters/P.svg";
import LetterR from "../assets/letters/R.svg";
import LetterS from "../assets/letters/S.svg";
import LetterT from "../assets/letters/T.svg";
import LetterU from "../assets/letters/U.svg";
import LetterW from "../assets/letters/W.svg";
import LetterY from "../assets/letters/Y.svg";
import LetterWild from "../assets/letters/Wild.svg";

export const LETTER_SVG: Record<Letter, string> = {
  [Letter.A]: LetterA,
  [Letter.B]: LetterB,
  [Letter.C]: LetterC,
  [Letter.D]: LetterD,
  [Letter.E]: LetterE,
  [Letter.F]: LetterF,
  [Letter.G]: LetterG,
  [Letter.H]: LetterH,
  [Letter.I]: LetterI,
  [Letter.K]: LetterK,
  [Letter.L]: LetterL,
  [Letter.M]: LetterM,
  [Letter.N]: LetterN,
  [Letter.O]: LetterO,
  [Letter.P]: LetterP,
  [Letter.R]: LetterR,
  [Letter.S]: LetterS,
  [Letter.T]: LetterT,
  [Letter.U]: LetterU,
  [Letter.W]: LetterW,
  [Letter.Y]: LetterY,
  [Letter.WILD]: LetterWild,
};
